import { createSlice } from '@reduxjs/toolkit';
import {
  NotificationHistoryFiltersSetSelectedAction,
  NotificationHistoryFiltersState,
  NotificationHistoryFiltersToggleActiveAction,
  NotificationHistoryFiltersToggleSelectedAction,
} from './notificationHistoryFilters.types';
import { makeActionCreator } from '../helpers';
import { toggleFilterState } from '../usersFilters/toggleFilterState';

export const initialNotificationHistoryFiltersState: NotificationHistoryFiltersState =
  {
    state: {
      notificationType: { label: 'Event Type', active: false },
      recipient: { label: 'Recipient', active: false },
      status: { label: 'Status', active: false },
    },
    selectedFilters: {},
  };

const { act } = makeActionCreator<NotificationHistoryFiltersState>();

export const notificationHistoryFiltersSlice = createSlice({
  name: 'notificationHistoryFilters',
  initialState: initialNotificationHistoryFiltersState,
  reducers: {
    toggleActiveFilters: (
      filterSliceState,
      action: NotificationHistoryFiltersToggleActiveAction
    ) => toggleFilterState(filterSliceState, action.payload),
    toggleSelectedFilters: act<
      NotificationHistoryFiltersToggleSelectedAction['payload']
    >(({ name, value }, { selectedFilters }) => {
      const currentValues = selectedFilters[name] || [];
      const isSelected = currentValues.includes(value);

      if (isSelected) {
        const nextValues = currentValues.filter(item => item !== value);
        if (nextValues.length === 0) {
          const nextSelectedFilters = { ...selectedFilters };
          delete nextSelectedFilters[name];
          return { selectedFilters: nextSelectedFilters };
        }
        return {
          selectedFilters: { ...selectedFilters, [name]: nextValues },
        };
      }

      return {
        selectedFilters: {
          ...selectedFilters,
          [name]: [...currentValues, value],
        },
      };
    }),
    setSelectedFilter: act<NotificationHistoryFiltersSetSelectedAction['payload']>(
      ({ name, value }, { selectedFilters }) => {
        const next = { ...selectedFilters };
        if (value === undefined || value === '') {
          delete next[name];
        } else {
          next[name] = [value];
        }
        return { selectedFilters: next };
      }
    ),
    reset: () => initialNotificationHistoryFiltersState,
  },
});
